/**
 * Motive adapter (formerly KeepTruckin) — IOT-ADAPTER-LIBRARY-1.
 *
 * Tier: third-party-tier-1 (major US fleet ELD / telematics)
 * Category: fleet_telematics
 *
 * TYPE-ONLY: device profiles and capability matrix are declared; live API
 * calls throw VendorNotIntegratedError. Full integration scheduled for a
 * follow-on session once Motive partner-API credentials are provisioned.
 *
 * Supported models (publicly documented): Motive Vehicle Gateway, Motive
 * Asset Gateway, Motive AI Dashcam. This adapter is parameterised on the
 * device.model field — capability matrix below is the union of supported
 * config keys; each model exposes a subset enforced by adapter logic when
 * integration ships.
 *
 * Patent anchor: F-IOT-ADAPTER-001 (hardware-agnostic IoT integration).
 */

import { NotImplementedAdapter } from '../NotImplementedAdapter.js';

const MOTIVE_CAPABILITIES = {
  configKeys: {
    reporting_interval_sec: {
      pushable: true,
      readable: true,
      range: [10, 3600],
      requiresActivation: false,
      unit: 'seconds',
      description: 'Vehicle / asset telemetry reporting interval',
    },
    geofence_enabled: {
      pushable: true,
      readable: true,
      enum: ['true', 'false'],
      requiresActivation: false,
      description: 'Enable onboard geofence alerting',
    },
    hours_of_service_enabled: {
      pushable: false,
      readable: true,
      enum: ['true', 'false'],
      requiresActivation: true,
      description: 'ELD HOS recording (DOT-regulated; provisioning-time only)',
    },
  },
  telemetryTypes: [
    'gps_position', 'speed_kph', 'heading_deg', 'odometer_km', 'engine_rpm',
    'fuel_level_pct', 'battery_voltage_v', 'cell_signal_dbm',
  ],
  alertingMode: 'hybrid',
  otaSupported: true,
  attestationSupported: false,
  rollbackSupported: false,
  pushLatencyExpectedMs: 15_000,
};

export class MotiveAdapter extends NotImplementedAdapter {
  constructor(device) {
    super(device, 'motive', MOTIVE_CAPABILITIES);
  }
}

export function createMotiveAdapterFactory() {
  return (device) => new MotiveAdapter(device);
}
